import React, { useState } from 'react';

import CenteredCircularProgress from '../../../../../../../../../../../lib/designSystem/CircularProgress';
import ShoppingCartRejected from './components/0.1_ShoppingCartRejected';
import ShoppingCartInReview from './components/1_ShoppingCartInReview';
import ShoppingCartAccepted from './components/2_ShoppingCartAccepted';
import ShoppingCartInTransfer from './components/3_ShoppingCartInTransfer';
import ShoppingCartActive from './components/4_ShoppingCartActive';

export interface FactoringRequest {
  id: number;
  status: string;
  sender: string;
  recipient: string;
  validUntil: Date;
  paymentDate: Date;
  amount: number;
  extraData: boolean;
  relation?: any;
  businessId: number;
}

const Summary = (props: any) => {
  const {
    shoppingCartType,
    openShoppingCart,
    setOpenShoppingCart,
    openRequest,
    setSuccessOpen,
    setFailureOpen,
    setUp,
    handleOpenDeleteConfirmModal,
    setLoading,
    handleOpenUpdateStatusModal,
    canEditRequest,
    setSelectedRequest,
  } = props;
  const [localLoading, setLocalLoading] = useState(false);

  if (localLoading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div>
      {localLoading ? <CenteredCircularProgress type="dialog" /> : <div></div>}
      {shoppingCartType === 'En revisión' && (
        <ShoppingCartInReview
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          setUp={setUp}
          setLoading={setLoading || setLocalLoading}
          handleOpenDeleteConfirmModal={handleOpenDeleteConfirmModal}
          handleOpenUpdateStatusModal={handleOpenUpdateStatusModal}
          canEditRequest={canEditRequest}
        />
      )}
      {shoppingCartType === 'Aceptada' && (
        <ShoppingCartAccepted
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
          setSuccessOpen={setSuccessOpen}
          updateStatus
          setUp={setUp}
          setLoading={setLoading || setLocalLoading}
          handleOpenDeleteConfirmModal={handleOpenDeleteConfirmModal}
          handleOpenUpdateStatusModal={handleOpenUpdateStatusModal}
          canEditRequest={canEditRequest}
        />
      )}
      {shoppingCartType === 'En giro' && (
        <ShoppingCartInTransfer
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
          handleOpenDeleteConfirmModal={handleOpenDeleteConfirmModal}
          handleOpenUpdateStatusModal={handleOpenUpdateStatusModal}
          canEditRequest={canEditRequest}
        />
      )}
      {(shoppingCartType === 'Activa' ||
        shoppingCartType === 'Congelada' ||
        shoppingCartType === 'Completada') && (
        <ShoppingCartActive
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          setUp={setUp}
          setLoading={setLoading || setLocalLoading}
          handleOpenDeleteConfirmModal={handleOpenDeleteConfirmModal}
          setSelectedRequest={setSelectedRequest}
        />
      )}
      {shoppingCartType === 'Rechazada' && (
        <ShoppingCartRejected
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
        />
      )}
    </div>
  );
};

export default Summary;
